<template>
	<div id="about">

		<div class="bioWrapper">
			<div 	class="bioImg left"
					:style="{
						'background-image': 'url(' + leftImage.url + ')'
					}">
            </div>

			<div class="bioText">
				<h1 class="header">about</h1>
				<div class="mobileImg" :style="{
						'background-image': 'url(' + customBackground.url + ')'
					}">
					<!-- <img :src="customBackground.url" /> -->
				</div>
				<p v-html="bio"></p>
			</div>

			<div 	class="bioImg right"
					:style="{
						'background-image': 'url(' + rightImage.url + ')'
					}">
        	</div>
		</div>

	</div>
</template>

<script>
export default{
	name:"About",
	props:['leftImage', 'rightImage', 'bio', 'customBackground']
}
</script>

<style scoped lang="scss">
	@import "~@/assets/scss/_variables.scss";

	#about{
		max-height: 90vh;
		height: 90vh;

		.bioWrapper{
			width: 100%;
			height: 100%;
			display: grid;
			grid-template-columns: 33.33% 33.33% 33.33%;

			.bioText{
				background: $nearWhite;
				max-height: 90vh;
				padding: 0 20px;

				.mobileImg{
					display: none;
				}

				.header{
					font-family: 'Montserrat', sans-serif;
					font-size: 3em;
					margin: 20px;
				}

				p{
					font-family: 'Raleway', sans-serif;
					margin: 10px 0;
					line-height: 1.3em;
				}
			}

			.bioImg{
				max-height: 90vh;
				background-position:top;
				background-repeat:no-repeat;
				background-size:cover;		
			}
		}
	}

	@media screen and (max-width: $regularLaptopWidth){
		#about{
			.bioWrapper{
				.bioText{
					p{
						margin: 20px 0;
						font-size: .8em;
					}
				}
			}
		}
	}

    @media screen and (max-width:$tabletWidth){
        #about{
        	.bioWrapper{
        		grid-template-columns: 0% 50% 50%;
    		}
        }
    }

    @media screen and (max-width:$largeMobile){
    	#about{
    		max-height: 100vh;
    		height: 100vh;

        	.bioWrapper{
        		grid-template-columns: 0% 100% 0%;

        		.bioText{
    				padding: 0;
        			max-height: 100vh;
        			display: grid;
        			grid-template-rows: 10% 25% 75%;

        			.header{
        				margin: 10px;
        				padding: 0 10px;
        			}

        			p{
        				padding: 10px;
        				margin: 0;
        			}

	        		.mobileImg{
	        			display: flex;
						width: 100%;
						height: 100%;
						background-position: center;
						background-size: contain;
						background-repeat: no-repeat;	        			  

	        			img{
	        				width: 100%;
	        				height: auto;
	        				margin: 0 auto;
	        			}
	        		}
        		}
    		}
    	}
    }

    @media screen and (max-width:$mediumMobile){
        #about{
        }
    }

    @media screen and (max-width:$smallMobile){
        #about{
        }
    }


</style>